import { FC } from 'react';
import { Modal } from 'antd';
import AddUser from './AddUser';
import UserList from './UserList';
import React from 'react';
import { useDispatch } from 'react-redux';
import { loadUsers } from './userSlice';
import { CommonContext, CommonContextType } from '../../contexts/CommonContext';
import { isUserAdmin } from '../../services/authenticationService';

const UserPage: FC = () => {
  const dispatch = useDispatch();
  const { isModalOpen, setModelChange, contextHolder, editUser, setEditUser } = React.useContext(CommonContext) as CommonContextType;

  const showModal = () => {
    setModelChange(true);
  };

  const handleCancel = () => {
    setEditUser(null)
    setModelChange(false);
  };

  React.useEffect(() => {
    dispatch(loadUsers());
  }, [dispatch]);

  return (
    <div className='padding'>
      {contextHolder}
      <h2>User List
        {isUserAdmin() ? <button className='top-button' onClick={showModal}>Create</button> : null}
      </h2>
      <br></br>
      <UserList />
      <Modal title={editUser?.id ? 'Edit User' : 'Create User'} open={isModalOpen} onCancel={handleCancel} maskClosable={false} footer={null}>
        <AddUser />
      </Modal>
    </div>
  );
};

export default UserPage;